module.exports = "/fonts/Trial-Proofer.woff?04bfa9db7c8d46fccd81991ce1afa78b";